<template>
  <div id="tab-hawb" class="app-main-inner">
    <common-hawb ref="hawb" :job="job" :form="form" :action="action" :context="context" :cooperate-edit="cooperateEdit" />
  </div>
</template>

<script>
import { TabHAWBPM } from './tabHAWBPM'

import CommonHawb from './components/CommonHAWB'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as NumberUtils from '@/utils/NumberUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'TabHawb',
  components: {
    CommonHawb
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pm: new TabHAWBPM(this),
      job: {},
      form: new AirCargoDoc().fillDefaultValue().getData(),
      syncCustomerShippingInfoBothBolAndBasicTab: false
    }
  },
  computed: {
    isEditing() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    enablePrint() {
      return !this.isEditing && this.job
    }
  },
  watch: {
  },
  created() {
    this.syncCustomerShippingInfoBothBolAndBasicTab = Number(this.context.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1
  },
  methods: {
    async onShow(row, isRefresh) {
      this.job = row
      await this.pm.fillView()
      // CARGO-30861 ID：4976 恩跃 空运-远程订舱分单运输条款选择：FREIGHT COLLECT ，HAWB页签还出现PP显示错误以及币种
      if (this.isEditing && this.form && !this.form.uuid && this.job.paymentTermHBL) {
        this.changeFreightTerm(this.form, this.job.paymentTermHBL)
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      if (this.form) {
        params.JOB_UUID = this.job.uuid
        params.DOC_UUID = this.form.uuid
        params.category = 'AEHAWB'
        params.ctx = new AirExportJob(this.job)
      }
      return params
    },
    async getSubmitData() {
      this.job.hawb = this.form.hblNbr2
      await this.fillModel(true)
      return {
        job: { ...this.job },
        airCargoDoc: [this.form]
      }
    },
    async fillModel(submitData = false) {
      if (this.$refs.hawb) {
        await this.$refs.hawb.fillModel(submitData)
      }
      CargoDocUtil.syncCargoDocSftToJob(this.job, this.form)
    },
    executeTask() {
      this.$refs.hawb.executeTask()
    },
    cWeightChangeHandler() {
      if (this.$refs.hawb) {
        this.$refs.hawb.cWeightChangeHandler()
      }
    },
    // 主单分单运费条款改变，对应的币种等都要相应改动
    changeFreightTerm(awbDoc, keyValue) {
      if (keyValue === 'CCBYPP') {
        awbDoc.currency = 'USD'
        awbDoc.wtVal = AirExportConstants.CC
        awbDoc.other = AirExportConstants.PP
      } else {
        awbDoc.wtVal = keyValue
        awbDoc.other = keyValue
        if (keyValue === AirExportConstants.CC) {
          awbDoc.currency = 'USD'
        } else if (keyValue === AirExportConstants.PP) {
          awbDoc.currency = 'CNY'
        }
      }
      // 修改数据
      this.refreshPPCC(awbDoc)
    },
    // 更新PP,CC值
    refreshPPCC(cargoDoc) {
      if (!cargoDoc) return
      this.changeWtvalPosition(cargoDoc, 'pp1', 'cc1', cargoDoc.wtVal)
      this.changeWtvalPosition(cargoDoc, 'pp2', 'cc2', cargoDoc.wtVal)
      this.changeWtvalPosition(cargoDoc, 'pp3', 'cc3', cargoDoc.wtVal)
      if (cargoDoc.docType === CargoDocConsts.HAWB) {
        if (!cargoDoc.pp4 && !cargoDoc.cc4 && !cargoDoc.pp5 && !cargoDoc.cc5) {
          cargoDoc.pp4 = 'AS ARRANGED'
        }
        if (!cargoDoc.pp4 && !cargoDoc.cc4) {
          cargoDoc.pp4 = cargoDoc.pp5
          cargoDoc.cc4 = cargoDoc.cc5
          cargoDoc.pp5 = ''
          cargoDoc.cc5 = ''
        }
        getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm).then(data => {
          if (data && data.length > 0) {
            for (const p of data) {
              if (this.job.paymentTermHBL && p.code === this.job.paymentTermHBL) {
                cargoDoc.accountingInfo = p.name
                break
              }
            }
          }
        })
      }
      this.changeWtvalPosition(cargoDoc, 'pp4', 'cc4', cargoDoc.other)
      this.changeWtvalPosition(cargoDoc, 'pp5', 'cc5', cargoDoc.other)
      this.refreshPPCC6(cargoDoc)
    },
    // 刷新PPCC6
    refreshPPCC6(cargoDoc) {
      const pp1 = !cargoDoc.pp1 ? 0 : NumberUtils.parseNumber(cargoDoc.pp1)
      const pp2 = !cargoDoc.pp2 ? 0 : NumberUtils.parseNumber(cargoDoc.pp2)
      const pp3 = !cargoDoc.pp3 ? 0 : NumberUtils.parseNumber(cargoDoc.pp3)
      const pp4 = !cargoDoc.pp4 ? 0 : NumberUtils.parseNumber(cargoDoc.pp4)
      const pp5 = !cargoDoc.pp5 ? 0 : NumberUtils.parseNumber(cargoDoc.pp5)
      if (!isNaN(pp1) && !isNaN(pp2) && !isNaN(pp3) && !isNaN(pp4) && !isNaN(pp5)) {
        const pp6 = pp1 + pp2 + pp3 + pp4 + pp5
        cargoDoc.pp6 = NumberUtils.formatNumber(pp6)
      } else if (isNaN(pp1)) {
        cargoDoc.pp6 = cargoDoc.pp1
      }

      const cc1 = !cargoDoc.cc1 ? 0 : NumberUtils.parseNumber(cargoDoc.cc1)
      const cc2 = !cargoDoc.cc2 ? 0 : NumberUtils.parseNumber(cargoDoc.cc2)
      const cc3 = !cargoDoc.cc3 ? 0 : NumberUtils.parseNumber(cargoDoc.cc3)
      const cc4 = !cargoDoc.cc4 ? 0 : NumberUtils.parseNumber(cargoDoc.cc4)
      const cc5 = !cargoDoc.cc5 ? 0 : NumberUtils.parseNumber(cargoDoc.cc5)
      if (!isNaN(cc1) && !isNaN(cc2) && !isNaN(cc3) && !isNaN(cc4) && !isNaN(cc5)) {
        const cc6 = cc1 + cc2 + cc3 + cc4 + cc5
        cargoDoc.cc6 = NumberUtils.formatNumber(cc6)
      } else if (isNaN(cc1)) {
        cargoDoc.cc6 = cargoDoc.cc1
      }
    },
    //
    changeWtvalPosition(cargoDoc, pp, cc, type) {
      const data = !cargoDoc[pp] ? cargoDoc[cc] : cargoDoc[pp]
      if (type === AirExportConstants.PP) {
        cargoDoc[pp] = data
        cargoDoc[cc] = ''
      } else if (type === AirExportConstants.CC) {
        cargoDoc[cc] = data
        cargoDoc[pp] = ''
      }
    },
    syncDocSft(doc, shipper, consignee, notify) {
      if (this.form && doc) {
        // 业务模式非直单时：基本页签收发通同步到HAWB页签收发通
        if (shipper) new AirCargoDoc(this.form).copyBasicShipper(doc, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (consignee) new AirCargoDoc(this.form).copyBasicConsignee(doc, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (notify) new AirCargoDoc(this.form).copyBasicNotify(doc, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
      }
    },
    endTabHandler() {
      return this.fillModel(false)
    }
  }
}
</script>

<style lang="scss">
  #app #tab-hawb {
    .el-form-item__content {
      width: 255px !important;
    }
    .label-none {
      .el-form-item__content {
        width: 490px !important;
      }
    }
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #8cc8ff;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }
  }
</style>
